import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { submitEnterpriseLead } from '../services/api';
import './EnterpriseLeadForm.css';

const INITIAL_FORM = {
  restaurantName: '',
  contactName: '',
  email: '',
  phone: '',
  restaurantCount: '',
  monthlyOrders: '',
  message: '',
};

function EnterpriseLeadForm({ onClose }) {
  const { t } = useTranslation();
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      await submitEnterpriseLead({
        ...form,
        restaurantCount: Number(form.restaurantCount),
        monthlyOrders: Number(form.monthlyOrders),
      });
      setSubmitted(true);
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="enterprise-lead-success">
        <div className="enterprise-lead-success-icon">&#10003;</div>
        <h3>{t('planSelection.enterpriseLeadSuccessTitle')}</h3>
        <p>{t('planSelection.enterpriseLeadSuccessMessage', { contactName: form.contactName })}</p>
        <button type="button" className="btn btn-primary" onClick={onClose}>
          {t('common.close')}
        </button>
      </div>
    );
  }

  return (
    <form className="enterprise-lead-form" onSubmit={handleSubmit}>
      <div className="enterprise-lead-form-grid">
        <div className="enterprise-lead-field">
          <label htmlFor="elf-restaurantName">{t('planSelection.enterpriseFieldRestaurant')}</label>
          <input
            id="elf-restaurantName"
            name="restaurantName"
            type="text"
            required
            value={form.restaurantName}
            onChange={handleChange}
            placeholder={t('planSelection.enterpriseFieldRestaurantPlaceholder')}
          />
        </div>

        <div className="enterprise-lead-field">
          <label htmlFor="elf-contactName">{t('planSelection.enterpriseFieldContact')}</label>
          <input
            id="elf-contactName"
            name="contactName"
            type="text"
            required
            value={form.contactName}
            onChange={handleChange}
            placeholder={t('planSelection.enterpriseFieldContactPlaceholder')}
          />
        </div>

        <div className="enterprise-lead-field">
          <label htmlFor="elf-email">{t('planSelection.enterpriseFieldEmail')}</label>
          <input
            id="elf-email"
            name="email"
            type="email"
            required
            value={form.email}
            onChange={handleChange}
            placeholder={t('planSelection.enterpriseFieldEmailPlaceholder')}
          />
        </div>

        <div className="enterprise-lead-field">
          <label htmlFor="elf-phone">{t('planSelection.enterpriseFieldPhone')}</label>
          <input
            id="elf-phone"
            name="phone"
            type="tel"
            value={form.phone}
            onChange={handleChange}
            placeholder={t('planSelection.enterpriseFieldPhonePlaceholder')}
          />
        </div>

        <div className="enterprise-lead-field">
          <label htmlFor="elf-restaurantCount">
            {t('planSelection.enterpriseFieldRestaurantCount')}
          </label>
          <input
            id="elf-restaurantCount"
            name="restaurantCount"
            type="number"
            min="1"
            required
            value={form.restaurantCount}
            onChange={handleChange}
            placeholder={t('planSelection.enterpriseFieldRestaurantCountPlaceholder')}
          />
        </div>

        <div className="enterprise-lead-field">
          <label htmlFor="elf-monthlyOrders">
            {t('planSelection.enterpriseFieldMonthlyOrders')}
          </label>
          <input
            id="elf-monthlyOrders"
            name="monthlyOrders"
            type="number"
            min="0"
            required
            value={form.monthlyOrders}
            onChange={handleChange}
            placeholder={t('planSelection.enterpriseFieldMonthlyOrdersPlaceholder')}
          />
        </div>
      </div>

      <div className="enterprise-lead-field enterprise-lead-field--full">
        <label htmlFor="elf-message">{t('planSelection.enterpriseFieldMessage')}</label>
        <textarea
          id="elf-message"
          name="message"
          rows="3"
          value={form.message}
          onChange={handleChange}
          placeholder={t('planSelection.enterpriseFieldMessagePlaceholder')}
        />
      </div>

      {error && (
        <div className="enterprise-lead-error">{t('planSelection.enterpriseLeadError')}</div>
      )}

      <div className="enterprise-lead-actions">
        <button type="button" className="btn btn-ghost" onClick={onClose}>
          {t('common.cancel')}
        </button>
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting
            ? t('planSelection.enterpriseLeadSubmitting')
            : t('planSelection.enterpriseLeadSubmit')}
        </button>
      </div>
    </form>
  );
}

export default EnterpriseLeadForm;
